import React, { useEffect, useMemo, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import axios from "axios";

import { IPrograma } from "../ProgramaListagem";
import Personalizacoes from "./Personalizacoes";
import ProgramaDefinicaoCard from "./ProgramaDefinicaoCard";
import { IResposta } from "./ProgramaDefinicaoCustom";

interface ProgramaEditModalProps {
  show: boolean;
  onHide: Function;
  programa?: IPrograma;
  onSave: (success: boolean, programa?: IPrograma) => void;
}

export default function ProgramaEditModal({
  show,
  onHide,
  programa,
  onSave,
}: ProgramaEditModalProps) {
  const [alvos, setAlvos] = useState<{ nome: string; id: number }[]>([]);
  const [titulo, setTitulo] = useState("");
  const [categoriaId, setCategoriaId] = useState<number>();
  const [respostas, setRespostas] = useState<IResposta[]>([]);
  const [personalizacoes, setPersonalizacoes] = useState<any[]>([]);

  useEffect(() => {
    if (!show || !programa) return;

    setTitulo(programa.titulo);
    setCategoriaId(programa.categoria_id);

    setAlvos(
      (programa.alvos || []).map((alvo) => ({
        nome: alvo.nome,
        id: alvo.id! as number,
      }))
    );

    setRespostas(
      (programa.escolhas || []).map((escolha) => ({
        id: escolha.id,
        campoprograma_id: escolha.campoprograma_id,
        valor: (() => {
          try {
            return JSON.parse(escolha.resposta);
          } catch {
            return escolha.resposta;
          }
        })(),
      }))
    );

    setPersonalizacoes(
      (programa.campos_personalizados || []).map((campo: any) => ({
        id: campo.id,
        nome: campo.nome,
        tipocampo_id: campo.tipocampo_id,
        obrigatorio: campo.obrigatorio,
        configuracao: campo.configuracao || {},
        opcoes: (campo.opcoes || []).map((op: any) => ({
          id: op.id,
          nome: op.nome,
        })),
      }))
    );
  }, [show, programa]);

  const handleUpdate = async () => {
    const response = await axios.put(`/programa/${programa?.id}`, {
      titulo,
      categoria_id: categoriaId,
      alvos,
      respostas,
      personalizacoes,
    });

    return response.data;
  };

  const isFormularioValido = useMemo(() => {
    const tituloValido = titulo.trim().length > 0;

    const categoriaValida =
      categoriaId !== undefined &&
      categoriaId !== null &&
      categoriaId > 0;

    const alvosValidos =
      alvos.length > 0 &&
      alvos.every((alvo) => alvo.nome && alvo.nome.trim().length > 0);

    return tituloValido && categoriaValida && alvosValidos;
  }, [titulo, categoriaId, alvos]);

  if (!programa) return null;

  return (
    <Modal size="xl" show={show} onHide={() => onHide()}>
      <Modal.Header closeButton>
        <Modal.Title>Editar Programa</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <ProgramaDefinicaoCard
          titulo={titulo}
          setTitulo={setTitulo}
          categoriaId={categoriaId}
          setCategoriaId={setCategoriaId}
          alvos={alvos}
          setAlvos={setAlvos}
          respostas={respostas}
          setRespostas={setRespostas}
        />

        <Personalizacoes
          personalizacoes={personalizacoes}
          setPersonalizacoes={setPersonalizacoes}
        />

        <div className="mt-3 d-flex justify-content-end">
          <Button
            disabled={!isFormularioValido}
            onClick={async () => {
              try {
                const programaAtualizado = await handleUpdate();
                onSave(true, programaAtualizado);
                onHide();
              } catch {
                onSave(false);
              }
            }}
          >
            Salvar Alterações
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}